<template>
    <div class="offer-details-container">
        <Offer :opportunity="opportunityInfo" />
        <p v-if="!authed" class="title">Log in or register to make an offer...</p>
    </div>
</template>
<script>
    import Offer from './parts/Offer.vue'

    export default {
        name: 'OfferDetails',
        props: {
            opportunityInfo: {
                type: Object,
                required: false
            },
            authed: {
                type: Boolean,
                required: true
            }
        },
        components: {
            Offer
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .offer-details-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        padding: 16px;
        border-radius: 16px;
        height: 100%;

        .title {
            margin-bottom: 0px;
            color: #dedede;
            font-variant-numeric: ordinal;
            @include base-font-16;
            font-weight: 600;
            line-height: 20px;
            text-wrap: wrap;
        }
    }
</style>
